var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseModalNexplanon = function SvgCloseModalNexplanon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.598 39.598"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 441",
    transform: "translate(-1210.168 -1795.167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F0AB99",
    "data-name": "Elipse 340",
    transform: "rotate(45 -1551.975 2382.285)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m1233.33 1809.362-3.363 3.363-3.362-3.363-2.242 2.242 3.362 3.362-3.362 3.362 2.242 2.242 3.362-3.362 3.362 3.362 2.242-2.242-3.362-3.362 3.362-3.362Z",
    "data-name": "Icon open-plus"
  }))));
};
export default SvgCloseModalNexplanon;